//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	ContactSources
} from 'utils/constants';

/**
 * @constant {String}
 */
const EVENT_CLOSE = 'close';
/**
 * @constant {String}
 */
const EVENT_NAVIGATE_CONTINUE = 'navigate:continue';

export default {
	props: {
		isVisible: {
			type: Boolean,
			required: true
		},
		requiredFields: {
			type: Array,
			required: true
		},
		destination: {
			type: String,
			required: true
		}
	},

	computed: {
		isPipedrive() {
			return this.destination === ContactSources.PIPEDRIVE;
		}
	},

	methods: {
		close() {
			this.$emit(EVENT_CLOSE);
		},
		navigateContinue() {
			this.$emit(EVENT_NAVIGATE_CONTINUE);
		}
	}
};

